import store from '@/redux/store'
import { SUBSCRIPTION_MODULES, ProductTypes } from '@/modules/base/util/constants'

// reducer
const initialState = () => Object.values(SUBSCRIPTION_MODULES).reduce((result, key) => ({ ...result, [key]: false }), {})

const SET_MODULE_ACCESS = 'permissions/SET_MODULE_ACCESS'
const SET_MODULES_ACCESS = 'permissions/SET_MODULES_ACCESS'

export default function reducer(state = initialState(), action) {
  switch (action.type) {
    case SET_MODULE_ACCESS:
      const { module, access } = action
      return { ...state, [module]: access }

    case SET_MODULES_ACCESS:
      const { modules } = action
      return { ...state, ...modules }

    default:
      return state
  }
};

// action creators
export const setModuleAccess = ({ module, access }) => ({
  type: SET_MODULE_ACCESS,
  module,
  access,
})

export const setModulesAccess = ({ modules }) => ({
  type: SET_MODULES_ACCESS,
  modules,
})

const convertName = (name) => {
  return name.replace('_', '').toLowerCase()
}

export const setModulesAccessBySubscription = async(subscription) => {
  const { activeDetails } = subscription

  let modules = {}
  for (const key of Object.values(SUBSCRIPTION_MODULES)) {
    const access = activeDetails.some(item => item.name.toLowerCase() === convertName(key))
    modules = { ...modules, [key]: access }
  }

  const hasActiveDocumentSubscription = subscription?.subscriptions?.some(sub =>
    sub.typeOfSubscription === ProductTypes.DOCUMENT
    && !sub.isExpired
    && !sub.isSubscriptionLocked,
  )
  if (hasActiveDocumentSubscription) {
    modules = { ...modules, [SUBSCRIPTION_MODULES.DOCUMENTS]: true }
  }

  store.dispatch(setModulesAccess({ modules }))
}
